import { defineMessages } from 'react-intl'

export default defineMessages({
  deleteVisit: {
    id: 'promptModal.deleteVisit',
    defaultMessage: 'Void Visit'
  },
  confirmText: {
    id: 'promptModal.confirmText',
    defaultMessage:
      'Void this visit? It will leave activity totals, while recorded payments and the audit trail remain.'
  },
  cancel: {
    id: 'promptModal.cancel',
    defaultMessage: 'Cancel'
  },
  delete: {
    id: 'promptModal.delete',
    defaultMessage: 'Void'
  }
})
